import Carousel from '../Carousel/Carousel';
import Buttons from '../Buttons/Buttons';
import Info from '../Info/Info';
import SelectedImage from '../SelectedImage/SelectedImage';
import useDebounce from '../../../../../hooks/shared/optimization/useDebounce';
import useChooseElf from '../../model/hooks/useChooseElf';

export default function Content({ isHiddenWishCard }) {
  const chooseElf = useChooseElf();
  return (
    <div className={`wish__content`}>
      <Carousel isHiddenWishCard={isHiddenWishCard} />
      <Buttons isHiddenWishCard={isHiddenWishCard} chooseElf={chooseElf} />
      <SelectedImage isHiddenWishCard={isHiddenWishCard} />
      <Info isHiddenWishCard={isHiddenWishCard} chooseElf={chooseElf} />
    </div>
  );
}
